export default {
    departments: [],
    department:{},
};